import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import s from './DeviationMosaic.scss';
/** Sidebar block layout id 3 */
var DeviationMosaic = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement("div", { className: s['root'] },
            React.createElement(DeviationSidebarMosaic, { streamId: "sidebar-mosaic-".concat(block.contentType), deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parentDeviation: parentDeviation }))));
};
DeviationMosaic.displayName = 'DeviationMosaic';
export default DeviationMosaic;
//# sourceMappingURL=DeviationMosaic.js.map